module.exports = __webpack_public_path__ + "img/common-status-success.a54ee193.svg";